import { render, staticRenderFns } from "./couponPreview.vue?vue&type=template&id=267f4b25&scoped=true&"
import script from "./couponPreview.vue?vue&type=script&lang=js&"
export * from "./couponPreview.vue?vue&type=script&lang=js&"
import style0 from "./couponPreview.vue?vue&type=style&index=0&id=267f4b25&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f4b25",
  null
  
)

export default component.exports